function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "22",
  viewBox: "0 0 32 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1 13.5c9.35 0 18.64-1 28-1M19 1l2.27 2.37 5.03 4.98c.5.48 1.04.95 1.52 1.46l1.28 1.45a7.14 7.14 0 001.07.81M29.9 12.24C28.57 13.55 26 15.5 26 15.5l-4.55 3.1L18 21",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));